// extracted by mini-css-extract-plugin
module.exports = {"Suggestion":"styles_Suggestion__1RTI2"};